import { kameApiUrl } from 'endpoints';
import { notificationServiceUrl } from '../../../endpoints';
import fetch from '../../../utils/fetch';
import { PaginationRequest } from './utils';

export const apiQueryPrograms = async companyId => {
  try {
    const res = await fetch( kameApiUrl, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'company-id': companyId
      },
      body: JSON.stringify( {
        query: `query{
          programs{
            id
            name
            status
          }
        }`
      } )
    } );
    const data = await res.json();
    return data.data.programs;
  } catch ( error ) {
    throw new Error( error );
  }
};

export const apiSearchNotifications = async ( values, companyId, pagination = new PaginationRequest() ) => {
  const reqBody = {
    companyId,
    ...values,
    pagination
  };
  try {
    const res = await fetch( `${ notificationServiceUrl }/reports`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify( reqBody )
    } );
    const data = await res.json();
    return data;
  } catch ( error ) {
    throw new Error( error );
  }
};

export const apiResendNotification = async ( selectedNotification ) => {
  try {
    const res = await fetch( `${ notificationServiceUrl }/resend/${ selectedNotification }`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
    } );
    return res;
  } catch ( error ) {
    throw new Error( error );
  }
};
